/** Error codes from the API envelope (bovid-api/src/common/exceptions/error-code.enum.ts). */
export type ServerErrorCode =
  | 'BAD_REQUEST'
  | 'VALIDATION_FAILED'
  | 'INVALID_CURSOR'
  | 'INVALID_ID'
  | 'UNAUTHORIZED'
  | 'TOKEN_EXPIRED'
  | 'FORBIDDEN'
  | 'ACCOUNT_LOCKED'
  | 'ACCOUNT_INACTIVE'
  | 'NOT_FOUND'
  | 'CONFLICT'
  | 'DUPLICATE_KEY'
  | 'PAYLOAD_TOO_LARGE'
  | 'RATE_LIMITED'
  | 'INTERNAL_ERROR'
  | 'SERVICE_UNAVAILABLE'
  | 'TIMEOUT';

/** Raised in the browser when no API response exists. */
export type ClientErrorCode = 'NETWORK_ERROR' | 'CANCELLED';

export type ErrorCode = ServerErrorCode | ClientErrorCode;

/** Every API error response has this shape. Branch on `code`, never on `message`. */
export interface ApiErrorBody {
  statusCode: number;
  code: ServerErrorCode;
  message: string;
  details?: unknown;
  requestId: string;
  path: string;
  timestamp: string;
}

/** Keyset pagination — the only list shape the API returns. There is no page number or total. */
export interface CursorPage<T> {
  data: T[];
  page: {
    limit: number;
    hasMore: boolean;
    /** Opaque; pass back as `cursor` for the next page. */
    nextCursor: string | null;
  };
}

export interface CursorQuery {
  limit?: number;
  cursor?: string;
}

/** Mirror of the API's RecordStatus enum (bovid-api/src/common/enums/record-status.enum.ts). */
export const RecordStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
} as const;
export type RecordStatus = (typeof RecordStatus)[keyof typeof RecordStatus];

/** A record list's ID order (registration order); the API's default is newest first. */
export type ListOrder = 'newest' | 'oldest';
